import styled from "styled-components";
import tw from "twin.macro";
import { isFieldsValid } from "..";
import styles from "../../../common/styles";
import { DPInput } from "../../../common/types";
import { fetchSubmit } from "../api";

export const SubmitButton = (props: DPInput) => {

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isFieldsValid()) {
      fetchSubmit();
    }
  };

  return (
    <Button onClick={handleSubmit} disabled={props.disabled}>
      Log In
    </Button>
  );
};

const Button = styled.button(() => [
  tw`w-full font-bold text-pink-800 text-[0.5rem] px-2 py-1 uppercase`,
  styles.border,
]);

export default SubmitButton